/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener("DOMContentLoaded", function () {
	let spImgList = [
		
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/ger-red.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/ger-white.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/ger-black.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/ger-yellow.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/ger-blue.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/eng-red.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/eng-white.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/eng-black.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/eng-yellow.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/eng-blue.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/combo2-1.png",
		"https://cdn.shopify.com/s/files/1/0728/3517/0472/files/combo2-2.png",
	];

	let sp_price1 = 8.99;
	let sp_price2 = 17.99;

	function calcTotal(price, num) {
		let result = Number(price) * Number(num);
		return result.toFixed(2);
	}
    let prods = window.product
  function getCur(){
    let num = $('#sp-opt-group1 div.active').attr('data-val')
    let color = $('#sp-opt-group2 div.active').attr('data-val')
    // let type = $('#sp-type div.active').attr('data-val')
    return prods.filter(item=> item.option1 == num && item.option2 == color)[0]
  }
  function changePrice(){
    let num = $('#calcNumber').val()
    let price = (getCur().price * num / 100).toFixed(2)
    let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    $(".sp_product_part .sp-price-group .off-font").html(off_font);

  }
  $('.sp-btn-style').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
	$(".sp-reduce").click(function () {
		let input = $(this).siblings("input")[0];
		let num = Number(input.value) - 1;
		if (num > 0) {
			input.value = num;
		}
		changePrice()
	});
	$(".sp-add").click(function () {
		let input = $(this).siblings("input")[0];
		let num = Number(input.value) + 1;
		input.value = num;
		changePrice()
	});

	$(".opt-group div").click(function () {
		$(this).siblings().removeClass("active");
		$(this).addClass("active");

		let colorOptions = $(".sp-opt-group1 div.active").index();
		let numOptions = $(".sp-opt-group2 div.active").index();
		let _index = numOptions;
		if((colorOptions == 3)&& numOptions >= 10){
            $(".sp-opt-group2 div")
            .siblings()
            .removeClass("active")
            .eq(0)
			.addClass("active")
        }
    
        if(colorOptions == 0 || colorOptions == 2 || colorOptions == 3){
            $(".sp-opt-group2 div")
            .siblings()
            .removeClass("disbled")
            .eq(11)
            .addClass("disbled");

            $(".sp-opt-group2 div")
            .eq(10)
            .addClass("disbled");
        }else{
            $(".sp-opt-group2 div").siblings().removeClass("disbled");
        }
		// _swiper.slideToLoop(_index);

		// 更新图标上的数字
		updateIconNumbers();
        changePrice()
	});


	// 根据选中的 Quantity 更新 sp-icon-wrap 内的数字显示
	function updateIconNumbers() {
		const idx = $(".sp-opt-group1 .sp-option.active").index();
		let buy = 1,
			free = 2;
		switch (idx) {
			case 0:
				buy = 1;
				free = 2;
				break;
			case 1:
				buy = 2;
				free = 3;
				break;
			case 2:
				buy = 3;
				free = 7;
				break;
			default:
				buy = 5;
				free = 15;
		}
		$(".sp_product_part .sp-icon-wrap .sp-content-1").text(buy + "kaufen");
		$(".sp_product_part .sp-icon-wrap .sp-content-2").text(free + "geschenkt");
	}


	updateIconNumbers();

	// 点击 Color 选项切换主图（更鲁棒的匹配）
	$(document).on("click", ".sp-opt-group2 .sp-item", function () {
		// 切换 active 状态
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		
		let newSrc = null;

        let colorOptions = $(".sp-opt-group1 div.active").index();
		let numOptions = $(".sp-opt-group2 div.active").index();

		if(colorOptions == 0 || colorOptions == 2 || colorOptions == 3){
            $(".sp-opt-group2 div")
            .eq(10)
            .removeClass("active")

			$(".sp-opt-group2 div")
            .eq(11)
            .removeClass("active")
        }

		// 处理多色组合（精确匹配包含这些颜色）
		if (colorOptions == 1 && numOptions >= 10) {
			if (numOptions == 10) {
				newSrc = "https://cdn.shopify.com/s/files/1/0728/3517/0472/files/combo2-2.png"; // German -> combo2-2
			} else if (numOptions == 11) {
				newSrc = "https://cdn.shopify.com/s/files/1/0728/3517/0472/files/combo2-1.png"; // English -> combo2-1
			} 
		} else {
			// 单色项：匹配颜色与语言
			if (numOptions < 10) newSrc = spImgList[numOptions];
		}

		// 如果是多色组合，仅在 PC 模式下调整 .sp-icon-wrap 的 right 为 20px；移动端不设置
		if (numOptions >= 10) {
			if (window.innerWidth > 1080) {
				$(".sp_product_part .sp-icon-wrap").css("right", "20px");
			} else {
				$(".sp_product_part .sp-icon-wrap").css("right", "");
			}
		} else {
			$(".sp_product_part .sp-icon-wrap").css("right", "");
		}

		if (newSrc) {
			$(".sp-combo img").attr("src", newSrc);
		}
	});

	// 倒计时
	function getRandomNum(min, max) {
		return Math.floor(Math.random() * (max - min)) + min;
	}

	let endTimeG;

	function cutDownTime() {
		let nowTime = new Date();
		let endTime = new Date(endTimeG);

		let leftTime = endTime.getTime() - nowTime.getTime();
		if (leftTime < 0) {
			setupNewCountdown();
			leftTime = 0;
		}
		let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
			leftM = Math.floor((leftTime / (1000 * 60)) % 60),
			leftS = Math.floor((leftTime / 1000) % 60);
		leftH = leftH >= 10 ? leftH : "0" + leftH;
		leftM = leftM >= 10 ? leftM : "0" + leftM;
		leftS = leftS >= 10 ? leftS : "0" + leftS;

		return {
			hour: leftH,
			minute: leftM,
			second: leftS,
		};
	}
	function setupNewCountdown() {
		const randomHour = getRandomNum(1, 9);
		const currentTime = new Date();
		endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
	}
	let intervalId;

	function getCutDownTime() {
		setupNewCountdown();
		if (intervalId) clearInterval(intervalId);
		intervalId = setInterval(function () {
			let cutDownTimeText = cutDownTime();
			$(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
			$(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
			$(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
		}, 1000);
	}

	getCutDownTime();

	new Swiper(".sp-swiper-fade-top", {
		spaceBetween: 10,
		effect: "fade",
		autoplay: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 2000,
		},
		speed: 2000,
	});

	// // 按钮轮播
	new Swiper(".sp-btn-loop", {
		spaceBetween: 10,
		autoplay: true,
		autoplay: {
			disableOnInteraction: false,
			reverseDirection: true,
		},
		loop: true,
	});

	new Swiper(".sp-swiper1", {
		spaceBetween: 60,
		autoplay: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 0,
		},
		loop: true,
		speed: 6000,
		slidesPerView: "auto",
	});
	// 无停顿跑马灯（marquee）配置：autoplay.delay=0, freeMode 匀速
	new Swiper(".sp-swiper-p5", {
		autoplay: {
			delay: 1, // 尽可能小（但不能为 0，部分浏览器会忽略）
			disableOnInteraction: false,
		},
		speed: 5000, // 滚动一个 slide 的时间拉长，配合短 delay 形成“慢速连续”
		loop: true,
		slidesPerView: "auto", // 关键！让每个 slide 宽度自适应内容
		spaceBetween: 20,
		// 允许手动触摸滚动（之前被禁用）
		allowTouchMove: true,
		freeMode: true, // 关键！允许自由滑动，不吸附到 slide
		centeredSlides: false,
		grabCursor: false,
		// 禁用其他干扰项
		watchSlidesProgress: true,
		simulateTouch: true,
	});
	new Swiper(".sp-swiper1-m", {
		spaceBetween: 30,
		autoplay: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 0,
		},
		loop: true,
		speed: 3000,
		slidesPerView: "auto",
	});
	new Swiper(".sp-part4-swiper", {
		spaceBetween: 30,
		autoplay: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 0,
		},
		loop: true,
		speed: 3000,
		slidesPerView: "auto",
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});

	new Swiper(".sp-swiper2", {
		spaceBetween: 16,
		autoplay: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 0,
		},
		loop: true,
		speed: 6000,
		slidesPerView: "auto",
	});

	// Responsive init for .sp-swiper3: only enable on mobile widths
	let spSwiper3 = null;
	function debounce(fn, wait) {
		let t = null;
		return function () {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, arguments), wait);
		};
	}

	function initOrDestroySpSwiper3() {
		const isMobile = window.innerWidth <= 1080; // adjust breakpoint if needed
		const el = document.querySelector(".sp-swiper3");
		if (!el) return;

		if (isMobile && !spSwiper3) {
			spSwiper3 = new Swiper(".sp-swiper3", {
				spaceBetween: 20,
				autoplay: {
					disableOnInteraction: false,
					delay: 0,
				},
				loop: true,
				speed: 6000,
				slidesPerView: 1.8,
			});
		} else if (!isMobile && spSwiper3) {
			try {
				spSwiper3.destroy(true, true);
			} catch (e) {
				console.warn("spSwiper3 destroy error", e);
			}
			spSwiper3 = null;
		}
	}

	// init on load
	initOrDestroySpSwiper3();
	// handle viewport changes
	window.addEventListener("resize", debounce(initOrDestroySpSwiper3, 150));

	// 初始化 sp-swiper-p3，使其自动播放并循环
	new Swiper(".sp-swiper-p3", {
		spaceBetween: 20,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		loop: true,
		speed: 800,
		slidesPerView: 2.9,
		centeredSlides: true,
	});
	// 初始化 sp-swiper-p3，使其自动播放并循环
	new Swiper(".sp-swiper-p3-m", {
		slidesPerView: 1.26, // 显示2.25个slide，实现左右各显示部分slide的效果
		spaceBetween: 20, // slide之间的间距
		centeredSlides: true, // 居中显示当前slide
		loop: true, // 循环播放
		autoplay: {
			delay: 3000, // 自动播放延迟3秒
			disableOnInteraction: false, // 用户操作后继续自动播放
		},
		pagination: {
			el: ".sp-part4-swiper-pagination", // 如果需要分页器
			clickable: true,
		},
		// spaceBetween: 20,
		// autoplay: true,
		// autoplay: {
		// 	disableOnInteraction: false,
		// 	delay: 3000,
		// },
		// loop: true,
		// speed: 800,
		// slidesPerView: 1.3,
		// centeredSlides: true, // 👈 关键！让 active slide 居中
	});

	jQuery(".sp-scroll2").slide({
		mainCell: ".nav-imgs",
		autoPlay: true,
		effect: "leftMarquee",
		interTime: 12,
		vis: 1,
		scroll: 1,
	});

	let _swiper = new Swiper(".sp-swiper-pro", {
		speed: 1,
		spaceBetween: 0,
	});

	function mainRender() {
		$(function () {
			$("#root").css("zoom", "normal");
			if (document.body.clientWidth <= 1080) {
				let scale = document.body.clientWidth / 1080;
				$("#root").css("zoom", scale);
			} else {
				const scale = document.body.clientWidth / 1920;
				$("#root").css("zoom", scale);
			}

			window.addEventListener(
				"resize",
				(function () {
					var timer;
					return function () {
						if (timer) clearTimeout(timer);
						timer = setTimeout(function () {
							$("#root").css("zoom", "normal");
							if (document.body.clientWidth <= 1080) {
								let scale = document.body.clientWidth / 1080;
								$("#root").css("zoom", scale);
							} else {
								const scale = document.body.clientWidth / 1920;
								$("#root").css("zoom", scale);
							}
						}, 100);
					};
				})()
			);
		});

		function lazyLoadImages() {
			// 懒加载
			const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
			const config = {
				rootMargin: "0px 0px 1300px 0px",
				threshold: 0,
			};

			const lazyLoadObserver = new IntersectionObserver(function (entries, observer) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						// 当图片进入视口时
						const image = entry.target;
						const dataSrc = image.getAttribute("data-src");
						image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
						lazyLoadObserver.unobserve(image); // 停止观察该图片
					}
				});
			}, config);

			images.forEach(function (image) {
				lazyLoadObserver.observe(image); // 开始观察每个图片
			});
		}

		function preloadImages(imageArray) {
			// 预加载
			// 检查数组数据结构
			if (Array.isArray(imageArray[0])) {
				// 处理二维数组
				imageArray.forEach((subArray) => {
					subArray.forEach((url) => {
						const img = new Image();
						img.src = url;
					});
				});
			} else {
				// 处理一维数组
				imageArray.forEach((url) => {
					const img = new Image();
					img.src = url;
				});
			}
		}

		lazyLoadImages();

		preloadImages(spImgList);

		var links = document.querySelectorAll('a[href^="#shopping"]');
		links.forEach(function (link) {
			link.addEventListener("click", function (event) {
				event.preventDefault(); // 阻止默认的跳转行为

				// 方式一
				const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
				const offsetTop = document.body.clientWidth <= 1080 ? targetElement.offsetTop - $(".sp-nav").height() : targetElement.offsetTop;
				let sptop = document.body.clientWidth <= 1080 ? 60 : 90;

				window.scroll({
					top: offsetTop * $("div#root").css("zoom") - sptop * $("div#root").css("zoom"),
					behavior: "smooth", // 使用 smooth 实现平滑滚动
				});
			});
		});

		// IOS字体多了间距的处理 给节点添加 sp_system 类名
		// 判断当前用户是安卓端还是iOS端
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		var isAndroid = /android/i.test(userAgent);
		var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
		var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

		if (isAndroid) {
			console.log("Android");
		} else if (isIOS) {
			console.log("iOS");
		} else if (isPC) {
			console.log("PC");
		} else {
			$(".sp_system").css("letter-spacing", "-4px");
		}
	}

	mainRender();

	// 标题文本渐出
	const graduallyList = document.getElementsByClassName("gradually");
	for (let gradually of graduallyList) {
		const spans = gradually.querySelectorAll("span");
		const paragraph = gradually.querySelector(".sp-sub-title");

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						// 给每个 span 和 i 动画
						spans.forEach((span, index) => {
							span.style.animation = `swift-up-fade 0.5s ease forwards`;
							span.style.animationDelay = `${index * 0.1}s`;

							const i = span.querySelector("i");
							if (i) {
								i.style.animation = `swift-up-fade 0.5s ease forwards`;
								i.style.animationDelay = `${index * 0.1}s`;
							}
						});

						// 段落
						const totalDelay = spans.length * 0.1 + 0.3;
						if (paragraph) {
							paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
							paragraph.style.animationDelay = `${totalDelay}s`;
						}

						observer.unobserve(gradually);
					}
				});
			},
			{
				threshold: 0.3,
			}
		);
		observer.observe(gradually);
	}

	// // 点击按钮
	// $(".sp-video-btn").click(function () {
	//   $(".sp-mask").css("display", "flex");
	// });

	// 菜单
	$(".sp-menu-btn").click(function (e) {
		$(".sp-menu-mask").show();
	});

	$(".sp-menu-mask").click(function (e) {
		// if ($(e.target).closest(".sp-menu-mask li").length > 0) {
		// } else {
		$(".sp-menu-mask").hide();
		// }
	});

	// 滚动隐藏顶部
	if ($(window).scrollTop() > $(".sp_header").height() * $("div#root").css("zoom")) {
		$(".sp_header-wrap").addClass("sp-fixed");
	} else {
		$(".sp_header-wrap").removeClass("sp-fixed");
	}

	let spTimer = null;
	let spHasShown = false; // 防止重复显示

	$(window).scroll(function () {
		if ($(window).scrollTop() > $(".sp_header").height() * $("div#root").css("zoom")) {
			$(".sp_header-wrap").addClass("sp-fixed");
		} else {
			$(".sp_header-wrap").removeClass("sp-fixed");
		}

		// 滚动添加底部
		if (spHasShown) return; // 已经显示就不再触发

		// 如果没有定时器，则开始计时
		if (!spTimer && $(window).scrollTop() > 800) {
			spTimer = setTimeout(function () {
				document.querySelector(".sp-btn-style2").style.display = "flex";
				spHasShown = true; // 标记为已显示
			}, 3000);
		}
	});

	$(document).on("click", ".sp_buy_now", function () {
		console.log("xxx111");
	});

	let initNum = 0;
	$(document).on("click", ".sp_add_cart", function () {
		// 购物车加购动效
		$(this).children("img").addClass("on");
		$(".sp-cart .num").show();
		setTimeout(function () {
			$(".cart-btn").children("img").removeClass("on");
		}, 500);
		$(" .sp-cart").addClass("on");
		setTimeout(function () {
			$(".sp-cart").removeClass("on");
		}, 500);

		var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            $(".cardNum").each(function () {
                $(this).html(result.item_count);
                $(this).removeClass("sp-gray");
            });
          });
        },
        dataType: "json",
      });
		// handleAddToCart(initNum);

		var imgs = $(".sp_product_part .swiper-slide-active").find("img");
		// 回退到主图（如果没有在 swiper 中找到 active slide 的图片）
		if (!imgs || imgs.length === 0) {
			imgs = $(".sp_product_part .sp-combo img");
		}

		imgs.each(function () {
			var $img = $(this);
			var flyer = $img[0].cloneNode(true);
			flyer.classList.add("sp_clone");

			// 将克隆节点追加到 body（fixed 定位相对于视口更可靠）
			$(".sp_product_part").append(flyer);


            $(flyer).css({
                width: $img[0].width,
                height: $img[0].height,
                background: "#e7e9ef",
                position: "fixed",
        
                top: $img[0].offsetTop,
                left: $img.offset().left,
                "z-index": 99,
            });
			let finish;
			if (document.body.clientWidth <= 1080) {
				finish = $(".sp-btn-style2 .sp-cart");
				var finishOffset = $(".sp-btn-style2 .sp-area2").offset() || { top: 0, left: 0 };
				var finishTop = $(".sp-btn-style2")[0].offsetTop;
				var finishLeft = $(".sp-btn-style2 .sp-area2")[0].offsetLeft + finish.width() / 2;

				$(flyer).animate(
					{
						top: finishTop,
						left: finishLeft,
						width: 50,
						height: 50,
						opacity: 0.4,
					},
					500,
					"linear",
					function () {
						$(this).animate(
							{
								width: 0,
								height: 0,
								opacity: 0,
							},
							0,
							function () {
								$(this).detach();
							}
						);
					}
				);
			} else {
				finish = $(".sp_pc .sp-cart");
				var finishOffset = finish.offset() || { top: 0, left: 0 };
				var finishTop = finishOffset.top - $(window).scrollTop();
				var finishLeft = finishOffset.left + finish.width() / 2;

				$(flyer).animate(
					{
						top: finishTop,
						left: finishLeft,
						width: 50,
						height: 50,
						opacity: 0.4,
					},
					500,
					"linear",
					function () {
						$(this).animate(
							{
								width: 0,
								height: 0,
								opacity: 0,
							},
							0,
							function () {
								$(this).detach();
							}
						);
					}
				);
			}
		});
	});

	// 问答
	$(".sp-qa2-question").on("click", function () {
		var $currentItem = $(this).closest(".sp-qa2-item");
		var $answer = $currentItem.find(".sp-qa2-answer");

		// 如果当前项已经打开 -> 关闭它
		if ($currentItem.hasClass("active")) {
			$answer.slideUp(300);
			$currentItem.removeClass("active");
		}
		// 如果当前项是关闭的 -> 开启它 (并关闭其他项)
		else {
			// 关闭其他所有项
			$(".sp-qa2-item").removeClass("active");
			$(".sp-qa2-answer").slideUp(300);

			// 开启当前项
			$currentItem.addClass("active");
			$answer.slideDown(300);
		}
	});

	// 文本渐出动画
	const graduallyList2 = document.getElementsByClassName("sp-fade-box");
	for (let gradually2 of graduallyList2) {
		const paragraph2 = gradually2.querySelectorAll(".sp-ani");

		const observerAni = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						paragraph2.forEach((span, index) => {
							span.style.animation = `sp-fade-in 1s ease forwards`;
							span.style.animationDelay = `${index * 0.5 + 0.5}s`;
						});

						observerAni.unobserve(gradually2);
					}
				});
			},
			{
				threshold: 0.3,
			}
		);
		observerAni.observe(gradually2);
	}
	// 文本渐出动画
	const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
	for (let gradually3 of graduallyList3) {
		const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

		const observerAni = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						paragraph3.forEach((span, index) => {
							span.style.animation = `sp-fade-left 1s ease forwards`;
							span.style.animationDelay = `${index * 0.3 + 1}s`;
						});

						observerAni.unobserve(gradually3);
					}
				});
			},
			{
				threshold: 0.3,
			}
		);
		observerAni.observe(gradually3);
	}

	// sp-line-step 进度条拖动功能（支持多个实例）
	const stepLines = document.querySelectorAll(".sp-line-step");

	stepLines.forEach((stepLine) => {
		const stepProgress = stepLine.querySelector(".sp-line-step-progress");
		const stepHandle = stepLine.querySelector(".sp-line-step-handle");

		if (!stepProgress || !stepHandle) return;

		let isStepDragging = false;

		function updateStepProgress(clientX) {
			const rect = stepLine.getBoundingClientRect();
			let percentage = ((clientX - rect.left) / rect.width) * 100;

			// 限制在 0-100% 之间
			percentage = Math.max(0, Math.min(100, percentage));

			// 更新进度条和手柄位置
			stepProgress.style.width = percentage + "%";
			stepHandle.style.left = percentage + "%";
		}

		// 鼠标事件
		stepHandle.addEventListener("mousedown", (e) => {
			isStepDragging = true;
			e.preventDefault();
		});

		stepLine.addEventListener("click", (e) => {
			if (!isStepDragging) {
				updateStepProgress(e.clientX);
			}
		});

		const handleMouseMove = (e) => {
			if (isStepDragging) {
				updateStepProgress(e.clientX);
			}
		};

		const handleMouseUp = () => {
			isStepDragging = false;
		};

		document.addEventListener("mousemove", handleMouseMove);
		document.addEventListener("mouseup", handleMouseUp);

		// 触摸事件（移动端）
		stepHandle.addEventListener("touchstart", (e) => {
			isStepDragging = true;
			e.preventDefault();
		});

		stepLine.addEventListener("touchstart", (e) => {
			if (e.target === stepLine) {
				const touch = e.touches[0];
				updateStepProgress(touch.clientX);
			}
		});

		const handleTouchMove = (e) => {
			if (isStepDragging) {
				const touch = e.touches[0];
				updateStepProgress(touch.clientX);
			}
		};

		const handleTouchEnd = () => {
			isStepDragging = false;
		};

		document.addEventListener("touchmove", handleTouchMove, { passive: false });
		document.addEventListener("touchend", handleTouchEnd);

		// 自动播放逻辑：循环填满到 100% 后重置为 0%
		let autoInterval = null;
		const autoFullMs = 3000; // 完整进度从 0 到 100 所需毫秒，可按需调整
		const tickMs = 50; // 更新频率（毫秒）

		function getCurrentPercent() {
			let w = 0;
			if (stepProgress.style.width) {
				w = parseFloat(stepProgress.style.width);
			} else {
				w = (stepProgress.clientWidth / stepLine.clientWidth) * 100 || 0;
			}
			if (isNaN(w)) w = 0;
			return w;
		}

		function setPercent(p) {
			p = Math.max(0, Math.min(100, p));
			stepProgress.style.width = p + "%";
			stepHandle.style.left = p + "%";
		}

		function startAutoPlay() {
			if (autoInterval) return;
			autoInterval = setInterval(() => {
				if (isStepDragging) return; // 拖动时暂停
				let cur = getCurrentPercent();
				const inc = (tickMs / autoFullMs) * 100;
				let next = cur + inc;
				if (next >= 100) {
					setPercent(100);
					// 短暂停留再重置
					setTimeout(() => {
						setPercent(0);
					}, 300);
				} else {
					setPercent(next);
				}
			}, tickMs);
		}

		function stopAutoPlay() {
			if (autoInterval) {
				clearInterval(autoInterval);
				autoInterval = null;
			}
		}

		// 鼠标/触摸悬停时暂停，离开时恢复
		stepLine.addEventListener("mouseenter", stopAutoPlay);
		stepLine.addEventListener("mouseleave", startAutoPlay);
		stepLine.addEventListener(
			"touchstart",
			(e) => {
				stopAutoPlay();
			},
			{ passive: true }
		);
		stepLine.addEventListener("touchend", (e) => {
			startAutoPlay();
		});

		// 在非拖动的点击后也更新并继续自动播放
		stepLine.addEventListener("click", (e) => {
			if (!isStepDragging) {
				// 保证自动播放在点击后继续运行
				startAutoPlay();
			}
		});

		// 启动自动播放
		startAutoPlay();
	});
});
